import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { Component, OnInit, OnChanges, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IKeyValueInterface } from './../../shared/config';
import { BookingService } from './../models/booking.service';
import { BookingOverviewList } from './../models/booking-overviewlist.model';
import { WeGoConfig, IAPIResponse, DataListModel, ApplicationRouteURL, BookingStatus } from '../../shared/config';

const moment = require("moment");

@Component({
  selector: 'wego-booking-history',
  template: require('../views/booking-history.component.html'),
  providers: [BookingService],
})
export class BookingHistoryComponent implements OnInit {

  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  apiErrorMsg: string;
  DataListModel: DataListModel;
  errorModel: IKeyValueInterface[];
  readMore: IKeyValueInterface[];
  bookingList: BookingOverviewList[];
  isLoading: boolean;
  isParentCheck: boolean;
  message: string;
  popupMessage: string;
  remarks: string;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  model: BookingOverviewList = new BookingOverviewList();
  isParentCheckEnable: boolean;
  remarkslength: number = 15;
  urlBooking: string;
  urlDefaultPage: string;
  urlDriverBookingInformation: string;
  urlSnailTrailDriver: string;

  @ViewChild('cancelModal') public cancelModal: any;
  @ViewChild('revokeAborkModal') public revokeAborkModal: any;
  @ViewChild('remarksModal') public remarksModal: any;

  get isAnyChecked(): boolean {
    if (this.bookingList) {
      let isCheck = this.bookingList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.bookingList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  constructor(private authService: AuthService,
    private bookigService: BookingService,
    private router: Router, private translate: TranslateService
  ) {

  }

  ngOnInit() {
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["licenceTag", "bookingReference", "translatedBookingStatus"];
    this.model = new BookingOverviewList();
    this.model.startDateTime = moment().utc().format('DD-MM-YYYY HH:mm');
    this.model.endDateTime = moment().utc().add(+1, 'M').format('DD-MM-YYYY HH:mm');
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.urlBooking = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING);
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlDriverBookingInformation = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING_INFORMATION_DRIVER);
    this.urlSnailTrailDriver = this.authService.GetURL(ApplicationRouteURL.URL_SNAIL_TRAIL_DRIVER);
    this.GetBookingHistory();
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.enableSeconds = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetBookingHistory();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetBookingHistory();
  }

  public OnDateSearch() {
    this.GetBookingHistory();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.bookigService.ExportBokingHistoryList(this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = "Booking" + new Date().toISOString() + ".csv";
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });;
  }

  private GetBookingHistory() {
    this.isLoading = true;
    this.bookigService.GetBookingHistoryList(this.DataListModel)
      .subscribe(
        res => {
          if (res.data) {
            this.bookingList = res.data;
            this.DataListModel.totalItems = res.totalRecords;
            this.DataListModel.infoMessage = res.error;
            this.isLoading = false;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetBookingHistory();
  }
  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetBookingHistory();
  }
  public OnParentCheck(isChecked: boolean) {
    this.bookingList.filter(y => y.bookingStatus == BookingStatus.CONFIRMED && y.startDateTime > moment().utc().format('DD-MM-YYYY HH:mm:ss')).forEach(x => x.isChecked = isChecked);
  }

  //Addedd for remarksModal

  public ShowRemakrsModal(remarks: string) {
    this.remarks = remarks;
    this.remarksModal.show();

  }
  public HideRemarksModal() {
    this.remarks = null;
    this.remarksModal.hide();
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/booking-history.component.ts